import React, {useEffect, useState} from 'react';
import {OnChangePlugin} from "@lexical/react/LexicalOnChangePlugin"
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $generateHtmlFromNodes, $generateNodesFromDOM } from "@lexical/html";
import { $getRoot, $insertNodes } from "lexical";

const CustomOnChangePlugin = (props) => {
    const { onChange, value } = props;
    const [editor] = useLexicalComposerContext()

    useEffect(() => {
        if(value) {
            editor.update(() => {
                const currentHTML = $generateHtmlFromNodes(editor);
                if(currentHTML !== value) {
                    $getRoot().clear();
                    const parser = new DOMParser();
                    const dom = parser.parseFromString(value, "text/html");
                    const nodes = $generateNodesFromDOM(editor, dom);
                    $insertNodes(nodes);
                }
            })
        }
    }, [value, editor]);

    const onEditorChange = (editorState) => {
        editorState.read(() => {
            onChange($generateHtmlFromNodes(editor))
        })
    }
    return (
        <OnChangePlugin onChange={(editorState) => onEditorChange(editorState)}/>
    )
};

export default CustomOnChangePlugin;